import PhotosModalContentMobile from '../src/PhotosModalContentMobile.tsx';
export default PhotosModalContentMobile;
